import { render, staticRenderFns } from "./kv-tab-panel.vue?vue&type=template&id=b2b8453c"
import script from "./kv-tab-panel.vue?vue&type=script&lang=js"
export * from "./kv-tab-panel.vue?vue&type=script&lang=js"
import style0 from "./kv-tab-panel.vue?vue&type=style&index=0&id=b2b8453c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports